<script>
import Schema from '../../share/form/Schema.js'

export default {
  name: 'form-schema',
  mixins: [
    Schema
  ],
  props: {
    service: {
      type: String,
      required: true
    }
  }
}
</script>
